import apis from "../../apis/api.actions";
// import { parseQueryParams } from "../../utils/formValidate";

export const updateStage = (entity, data) =>
  apis.createData(`/${entity}/change-stage`, data).then((res) => res);
